module.exports = __webpack_public_path__ + "img/smg.mp5.6e13a204.png";